import React from "react";
import LineChart from "../../Chart/LineChart";

function PowerSpotCharts({ data }) {
  return (
    <>
      <div>
        <p className="text-center chartTitleP">NL Spot Power</p>

        <div className="powerPageCharts">
          <LineChart
            yAxisTitle="€/MWh"
            data={data}
            colors={["#004474", "#70cff9"]}
            showLegend
          />
        </div>
        <div className="powerPrintedCharts">
          <LineChart
            yAxisTitle="€/MWh"
            data={data}
            colors={["#004474", "#70cff9"]}
            showLegend
            height={250}
          />
        </div>
      </div>
    </>
  );
}

export default PowerSpotCharts;
